/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandFiverr = createReactComponent("outline", "brand-fiverr", "IconBrandFiverr", [["path", { "d": "M15 3h-2a6 6 0 0 0 -6 6h-3v4h3v8h4v-7h4v7h4v-11h-8v-1.033a1.967 1.967 0 0 1 2 -1.967h2v-4z", "key": "svg-0" }]]);

export { IconBrandFiverr as default };
//# sourceMappingURL=IconBrandFiverr.mjs.map
